import styled from '@common/theme/styled-components';

export const FormError = styled.div`
  color: ${(props) => props.theme.brandRedColor};
  font-size: ${(props) => props.theme.xsmallFontSize};
`;
